module.exports = __webpack_public_path__ + "img/dashboard-box.ce0a70a2.png";